export default __webpack_public_path__ + "static/media/glasses.5e29f946.svg";